import { Heart, Smile, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SITE, NAV_CONTENT, CONTACT } from '../data/content';

export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-800 via-purple-900 to-pink-900 text-white py-12" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        
        {/* 4 oszlopos reszponzív elrendezés */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Smile className="w-6 h-6 text-orange-400" aria-hidden="true" />
              <span className="text-xl font-medium" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {SITE.name}
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {SITE.personName} – Gyógypedagógus, logopédus, szurdopedagógus
            </p>
            <p className="text-gray-500 text-sm mt-2">{SITE.location}</p>
          </div>

          {/* Links */}
          <nav aria-label="Lábléc navigáció">
            <h2 className="font-medium text-gray-300 mb-4 uppercase tracking-wide text-xs">
              Navigáció
            </h2>
            <ul className="space-y-2 list-none p-0 m-0">
              {NAV_CONTENT.mainLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm no-underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Services */}
          <nav aria-label="Szolgáltatások navigáció">
            <h2 className="font-medium text-gray-300 mb-4 uppercase tracking-wide text-xs">
              Szolgáltatások
            </h2>
            <ul className="space-y-2 list-none p-0 m-0">
              {NAV_CONTENT.serviceLinks.slice(1).map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm no-underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* ÚJ GEO SZEKCIÓ: Kapcsolat és Helyszín */}
          <address className="not-italic" aria-label="Kapcsolat és helyszín">
            <h2 className="font-medium text-gray-300 mb-4 uppercase tracking-wide text-xs">
              Kapcsolat & Helyszín
            </h2>
            <ul className="space-y-4 list-none p-0 m-0 text-sm text-gray-400">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" aria-hidden="true" />
                <div>
                  <span className="block font-medium text-gray-300 mb-1">{SITE.location}</span>
                  <span className="text-xs leading-relaxed text-gray-500">
                    Logopédiai ellátás, vizsgálat és fejlesztés Dunakeszi és a környező agglomeráció (Fót, Göd, Vác, Szentendre, Veresegyház), valamint Budapest IV. kerület (Újpest) vonzáskörzetéből érkezők számára is.
                  </span>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-orange-400 flex-shrink-0" aria-hidden="true" />
                <a href={`tel:${CONTACT.phoneTel}`} className="hover:text-orange-400 transition-colors duration-200">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-orange-400 flex-shrink-0" aria-hidden="true" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-orange-400 transition-colors duration-200">
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </address>

        </div>

        {/* Alsó sáv */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} {SITE.personName}. Minden jog fenntartva.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <Link to="/adatkezeles" className="text-gray-400 hover:text-white transition-colors text-sm">Adatkezelési Tájékoztató</Link>
          </div>
          <div className="flex items-center gap-1 text-gray-400 text-sm">
            <span>Készült</span>
            <Heart className="w-3.5 h-3.5 text-pink-400 fill-pink-400 mx-1" aria-hidden="true" />
            <span className="sr-only">szeretettel</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
